import Navbar from "../components/landing/Navbar";
import HeroAbout from "../components/landing/HeroAbout";
import Services from "../components/landing/Services";
import WhyChooseMe from "../components/landing/WhyChooseMe";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="font-body bg-white text-[#0A192F]">
      <Navbar />
      <HeroAbout />
      <Services />
      <WhyChooseMe />
      <Contact />
      <Footer />
    </main>
  );
}
